<template>

  <BModal :open="langSwitcherModal"
          @hide="hideModal">
    <HCHModalHeader :close="hideModal"/>
    <form @submit.prevent="toggleLocation">
      <div class="hch_modal-body">
        <h2 class="h3">
          {{ $t('title-modal-lang-switcher') }}
        </h2>
        <p class="mb-2 fw-semibold">
          {{ $t('desc-modal-lang-switcher') }}
        </p>
        <select id="modal_desktop_menu_lang_picker" class="form-select picker custom-select mb-4"
                v-model="selectedCountry" required
                @change="toggleLanguageByCountry">
          <option :value="locale" v-for="locale in countries">
            {{ $t(`lang-country-picker-country-${locale.code}`) }}
          </option>
        </select>
        <p class="mb-2 fw-semibold">
          {{ $t('desc2-modal-lang-switcher') }}
        </p>

        <select id="modal_desktop_menu_country_picker" class="form-select picker custom-select mb-4"
                v-model="selectedLocale" required>
          <option :value="locale"
                  v-for="locale in locales.filter(l => l.enabled === true && selectedCountry.languages.some(cl => cl === l.code))">
            {{ $t(`lang-country-picker-lang-${locale.code}`) }}
          </option>
        </select>
        <div class="text-end">
          <button class="btn btn-first text-end" type="submit">
            {{ $t('select') }}
          </button>
        </div>

      </div>
    </form>
  </BModal>
</template>

<script setup lang="ts">

import locales from "~/lib/data/locales.json";
import countries from "~/lib/data/web_countries.json";
import BModal from "~/components/web/parts/b-modal";
import HCHModalHeader from "~/components/web/parts/modals/hch_modal_header";
import {ref, watch} from "vue";
import {clearObserverObj} from "../../../../../lib/functions";
import {useState} from "#app";
import {obtainActiveLocale, obtainActiveWebCountry} from "~/composables/master_page";

const props = defineProps({
  open: Boolean
});
const emit = defineEmits(['hideLanguageModal']);

const activeLocale = obtainActiveLocale();
const activeWebCountry = obtainActiveWebCountry();

const langSwitcherModal = ref(false);
const selectedCountry = ref(clearObserverObj(activeWebCountry));
const selectedLocale = ref(clearObserverObj(activeLocale));


watch(() => props.open, () => {
  langSwitcherModal.value = props.open
})

const hideModal = () => {
  langSwitcherModal.value = false;
  emit('hideLanguageModal');
}

const toggleLanguageByCountry = () => {
  selectedLocale.value = locales.find(l => l.code === selectedCountry.value.code);
}

const toggleLocation = () => {
  //useState("first_preload").value = true;
  window.location.href = `/${selectedLocale.value.iso}-${selectedCountry.value.code}`;
}
</script>
